export default class ProgressBar {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.totalWidth = 0;
        this.widthWithoutMan = 0;
        this.fishWidth = 0;
        this.fishermanWidth = 0;
        this.totalSegments = 0;
        this.currentIndex = 0;
        this.fisherman = wrapper.querySelector(".swiper-progress__fisherman");
        this.fish = wrapper.querySelector(".swiper-progress__fish");
        this.fishingLine = this.createLine();
        this.setWidth();
        this.initResizeEvent();
    }
    createLine() {
        var _a, _b;
        const lineDiv = document.createElement("div");
        lineDiv.classList.add("swiper-progress__line");
        lineDiv.style.position = "absolute";
        lineDiv.style.height = "1px";
        lineDiv.style.top = "0";
        lineDiv.style.right = `${((_b = (_a = this.fisherman) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0) - 1}px`;
        lineDiv.style.width = `${(this.widthWithoutMan - this.fishWidth) + 10}px`;
        lineDiv.style.backgroundColor = "#000";
        this.wrapper.insertAdjacentElement("beforeend", lineDiv);
        return lineDiv;
    }
    resetLineWidth() {
        this.fishingLine.style.width = `${(this.widthWithoutMan - this.fishWidth) + 10}px`;
    }
    updateTotalSegments(total) {
        this.totalSegments = total;
    }
    setWidth() {
        var _a, _b, _c, _d;
        this.fishWidth = (_b = (_a = this.fish) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
        this.fishermanWidth = (_d = (_c = this.fisherman) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0;
        this.totalWidth = this.wrapper.offsetWidth;
        this.widthWithoutMan = (this.totalWidth - this.fishermanWidth);
    }
    handleSwiperChange(currIndex, direction = "next") {
        var _a, _b;
        const segmentWidth = this.widthWithoutMan / this.totalSegments;
        const fishLeft = (segmentWidth * currIndex);
        if (this.fish) {
            this.fish.style.left = `${fishLeft}px`;
        }
        if (this.fishingLine) {
            // If fish is pointing left, measure from left of image else add width of image to find right edge
            // Also add an extra buffer if pointing right as the fish mouth is concave
            const directionOffset = (direction === "next" ? (this.fishWidth - 3) : 0);
            const fishX = fishLeft + directionOffset;
            // Height of the wrapper minus half the fish to get the middle of mouth
            const fishY = (this.wrapper.offsetHeight - (((_b = (_a = this.fish) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 0) / 2)) - 2;
            // Calc length of line
            const length = Math.sqrt((Math.pow((fishX - this.widthWithoutMan), 2)) + (Math.pow(fishY, 2)));
            // Calc angle between the 2 points
            const angle = (Math.atan2(fishY, fishX - this.widthWithoutMan) * 180) / Math.PI;
            this.fishingLine.style.width = `${length}px`;
            this.fishingLine.style.transform = `rotate(-${180 - angle}deg)`;
        }
        this.currentIndex = currIndex;
    }
    initResizeEvent() {
        window.addEventListener("resize", () => {
            this.setWidth();
            this.resetLineWidth();
            this.handleSwiperChange(this.currentIndex);
        });
    }
}
